import LoginSurvice from "../../Service/Login/LoginService.ts";
import { CustomAlert } from "../../Utils/CustomModal/CustomModal";
import { LoadingHide, loadingShow } from "../loading/loadingAction.js";

export const loginRequest = () => {
  return { type: "LOGIN_REQUEST" };
};

export const loginSuccees = (user) => {
  return { type: "LOGIN_SUCCEES", payload: user };
};

export const loginFailed = (error) => {
  return { type: "LOGIN_FAILED", payload: error };
};

const loginUser = (user, navigator) => {
  return async (dispatch) => {
    dispatch(loadingShow());
    dispatch(loginRequest());
    try {
      var req = await LoginSurvice(user);
      dispatch(loginSuccees(req.data.user_role));
      localStorage.setItem("role", req.data.user_role);
      localStorage.setItem("token", req.data.access_token);
      if (req.data.user_role === "emp") {
        navigator("/admin-dashboard");
      } else if (req.data.user_role === "stu") {
        navigator("/dashboard");
      }
      CustomAlert.success(
        "ورود با موفقیت انجام",
        "به پیشخوان دانشگاه علوم فنون خوش آمدید."
      );
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        dispatch(loginFailed(error.response.data.message));
        CustomAlert.error("خطا", error.response.data.message);
      } else {
        dispatch(loginFailed("خطایی در برقراری ارتباط با سرور رخ داده است."));
        CustomAlert.error(
          "خطا",
          "خطایی در برقراری ارتباط با سرور رخ داده است."
        );
      }
    } finally {
      dispatch(LoadingHide());
    }
  };
};

export default loginUser;
